const RENTALS_LINKS = {
  RENTALS_LINKS_PARTNER_LINKS: 'RENTALS_LINKS_PARTNER_LINKS',
  RENTALS_LINKS_PARTNER_LINKS_DETAILS: 'RENTALS_LINKS_PARTNER_LINKS_DETAILS',
};

export default RENTALS_LINKS;
